/*
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

angular.module('zeppelinWebApp').controller('AccountCtrl', AccountController);

function AccountController($rootScope, $scope, $http, $timeout, baseUrlSrv, ngToast) {
  'ngInject';

  $scope.fields = [
    {
      'field': 'tokenId',
      'display': 'Token Id',
    },
    {
      'field': 'description',
      'display': 'Description',
    },
    {
      'field': 'createdAt',
      'display': 'Creation Date',
    },
    {
      'field': 'expiresAt',
      'display': 'Expiration Date',
    },
    {
      'field': 'disabled',
      'display': 'Status',
    },
  ];


  ngToast.dismiss();

  $scope.accessTokens = [];

  $scope.sortField = 'expiresAt';
  $scope.ascending = true;
  $scope.token = '';
  $scope.hasAccessTokenPermission = $rootScope.hasMagpieRole('AccessToken');

  let getAccessTokens = function() {
    $http.get(baseUrlSrv.getRestApiBase() + '/magpie/access-token')
      .success(function(data, status, headers, config) {
        $scope.accessTokens = data;

        console.log('Success %o %o', status, $scope.accessTokens);
      })
      .error(function(data, status, headers, config) {
        if (status === 401) {
          showToast('You do not have permission on this page', 'danger');
          setTimeout(function() {
            window.location = baseUrlSrv.getBase();
          }, 3000);
        }
        console.log('Error %o %o', status, data.message);
      });
  };

  $scope.getExpiresWindow = function(date) {
    let days = Math.floor((Date.parse(date) - new Date())/1000/60/60/24);

    if (days < 0) {
      return 'expired';
    } else if (days === 1) {
      return '1 day';
    } else {
      return days + ' days';
    }
  };

  $scope.addNewToken = function() {
    $http.post(baseUrlSrv.getRestApiBase() + '/magpie/access-token')
      .success(function(data, status, headers, config) {
        showToast('Successfully created personal access token.', 'success');
        $scope.token = data.token;
        angular.element('#tokenModal').modal('toggle');
        getAccessTokens();
        console.log('Success %o %o', status, data.message);
      })
      .error(function(data, status, headers, config) {
        showToast('Error saving personal access token.', 'danger');
        console.log('Error %o %o', status, data.message);
      });
  };

  $scope.copyTokenToClipboard = function() {
    navigator.clipboard.writeText($scope.token);
  };

  angular.element('#tokenModal').on('hidden.bs.modal', function(e) {
    $scope.token = '';
  });

  $scope.updateTokenStatus = function(tokenId, disabled) {
    $http.put(baseUrlSrv.getRestApiBase() + '/magpie/access-token/' + tokenId + '/status/' + disabled)
      .success(function(data, status, headers, config) {
        showToast('Successfully updated personal access token status.', 'success');
        getAccessTokens();
        console.log('Success %o %o', status, data.message);
      })
      .error(function(data, status, headers, config) {
        showToast('Error updating personal access token status.', 'danger');
        console.log('Error %o %o', status, data.message);
      });
  };

  $scope.editToken = {tokenId: null, description: null};
  $scope.openDescriptionModal = function(tokenId, description) {
    $scope.editToken['description'] = description;
    $scope.editToken['tokenId'] = tokenId;
    angular.element('#tokenDescriptionModal').modal('toggle');
  };

  $scope.updateTokenDescription = function() {
    $http.put(baseUrlSrv.getRestApiBase() + '/magpie/access-token/' + $scope.editToken.tokenId +
      '/description', $scope.editToken.description)
      .success(function(data, status, headers, config) {
        showToast('Successfully updated personal access token description.', 'success');
        getAccessTokens();
        console.log('Success %o %o', status, data.message);
      })
      .error(function(data, status, headers, config) {
        showToast('Error updating personal access token description.', 'danger');
        console.log('Error %o %o', status, data.message);
      });
  };

  $scope.deleteToken = function(tokenId) {
    $http.delete(baseUrlSrv.getRestApiBase() + '/magpie/access-token/' + tokenId)
      .success(function(data, status, headers, config) {
        showToast('Successfully deleted personal access token.', 'success');
        getAccessTokens();
        console.log('Success %o %o', status, data.message);
      })
      .error(function(data, status, headers, config) {
        showToast('Error deleting personal access token.', 'danger');
        console.log('Error %o %o', status, data.message);
      });
  };

  $scope.handleSortClick = function(field) {
    $timeout(function() {
      if (field === $scope.sortField) {
        $scope.ascending = !$scope.ascending;
      } else {
        $scope.sortField = field;
        $scope.ascending = true;
      }
    });
  };


  function showToast(message, type) {
    const verticalPosition = 'bottom';
    const timeout = '3000';

    if (type === 'success') {
      ngToast.success({content: message, verticalPosition: verticalPosition, timeout: timeout});
    } else if (type === 'info') {
      ngToast.info({content: message, verticalPosition: verticalPosition, timeout: timeout});
    } else {
      ngToast.danger({content: message, verticalPosition: verticalPosition, timeout: timeout});
    }
  }

  let init = function() {
    getAccessTokens();
  };

  init();
}



// WEBPACK FOOTER //
// ./src/app/account/account.controller.js